import React, { useCallback } from 'react';
import FormRadioInput from '../../../shared/forms/formRadioInput.component';
import Spinner from '../../../shared/spinner.component';

import { TabHeader } from '../shared/tabHeader.component';
import { useUpdateLockClientFlag, useUpdateMaintenanceFlag } from '../../../shared/mutations/clientAdministration';
import { YES_FLAG, NO_FLAG } from '../../../shared/constants';
import { AdminOptionWrapper } from '../shared/adminOption.component';
import { useMaintenanceAndLockFlag } from '@queries/clientAdministration';

const yesNoFlagOptions = [{ label: 'Yes', value: YES_FLAG }, { label: 'No', value: NO_FLAG }];


const MaintenanceModeAndLockTab: React.FC<{}> = () => {
  const {
    data: { maintenanceFlag, lockFlag },
    isFetching: isFetchingMaintenanceAndLockFlag,
  } = useMaintenanceAndLockFlag();

  const {
    mutate: updateMaintenanceFlag,
    isLoading: isUpdatingMaintenanceFlag,
  } = useUpdateMaintenanceFlag();

  const {
    mutate: updateLockFlag,
    isLoading: isUpdatingLockFlag,
  } = useUpdateLockClientFlag();

  const onMaintenanceRadioChange = useCallback(
    event => updateMaintenanceFlag({ maintenanceFlag: event.target.value }),
    [updateMaintenanceFlag]
  );

  const onLockFlagRadioChange = useCallback(
    event => updateLockFlag({ lockFlag: event.target.value }),
    [updateLockFlag]
  );

  const isLoading = isFetchingMaintenanceAndLockFlag || isUpdatingMaintenanceFlag || isUpdatingLockFlag;

  return (
    <div className="client-admin-maintenance-mode-tab">
      <div className="container-fluid">
        <div className="application-settings-form">
          <TabHeader label="Maintenance Mode" />
          <AdminOptionWrapper label="Set Maintenance Mode">
            <FormRadioInput
              name="Maintenance Mode"
              value={maintenanceFlag}
              onChange={onMaintenanceRadioChange}
              options={yesNoFlagOptions}
              disabled={isLoading}
            />
            {isLoading && <Spinner small />}
          </AdminOptionWrapper>
          <AdminOptionWrapper label="Lock client">
            <FormRadioInput
              name="Lock Client"
              value={lockFlag}
              onChange={onLockFlagRadioChange}
              options={yesNoFlagOptions}
              disabled={isLoading}
            />
            {isLoading && <Spinner small />}
          </AdminOptionWrapper>
        </div>
      </div>
    </div>
  );
};

export default MaintenanceModeAndLockTab;
